import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _typeof from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.array.map.js";
import "regenerator-runtime/runtime.js";
import { useI18n } from "vue-i18n";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import BookingModule from "@/store/modules/booking";
import { PCTypes, RetailOptionType } from "@/types/db/product-category";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { computed, ref, defineComponent } from "vue";
import ModalModule from "@/store/modules/modal";
import { formatAndConvertToLocale, formatDateTime } from "@/utils/helpers/dates";
import { getLanguage } from "@/utils/helpers/lang";
import { PSSType } from "@/types/db/product-slot-state";
import { createImageproxyUrl } from "@/utils/helpers/pictures";
import { PCSELECT_IMAGE_HEIGHT, PCSELECT_IMAGE_MEASUREMENT_UNIT, PCSELECT_IMAGE_WIDTH } from "@/constants/style";
import { getProductCategoryByPrice, sellOnSoldOut } from "@/utils/helpers/product-category";
import { getPriceNonAutomaticAddons } from "@/utils/vue-helpers/product-slot-state";
import dayjs from "dayjs";
import { fetchAllPCsTimeslotsByTimeRange, getFutureTimeSlotsByProductCategory2 } from "@/utils/helpers/timeslots";
import { addToBasket } from "@/utils/vue-helpers/product-category";
import { deleteUnconfirmedTickets } from "@/utils/vue-helpers/booking";
import { debounce } from "lodash";
import { LogService } from "@/services/logging";
import NotificationService from "@/services/notification.service";
import { areObjectsEqual } from "@/utils/helpers/common";

var __default__ = defineComponent({
  name: ModalComponents.Addons,
  props: {
    modalProps: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getAddons();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  setup: function setup(props) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var _useI18n, t, dialogVisible, mainProductCategory, currentLanguage, mainTicketTimeSlot, addons, addonsData, groupedAddons, pricesCount, pricesBookingCount, isLoading, timeSlotsModalVisible, timeSlotsModalData, addonsDatepicker, selectedDate, addonsLoading, maxDaysBeforeMainTicket, maxDaysAfterMainTicket, showDatePicker, priceDescriptionMaxLength, PriceMaxQtyConstraint, PriceQtyLimitReason, isMainPcRetail, productCategoryName, pcselectPictureSize, isDisabled, pricesDiff, selectedBooking, modalTitle, modalHeaderTitle, showAddonsDates, packageQuantities, packageMaxQtyError, packageMinQtyError, adjustAddonInterval, getAddonTimeSlotsData, _getAddonTimeSlotsData, getAddons, _getAddons, priceName, priceDescription, truncatePriceDescription, togglePriceDescription, isPriceValueEditable, getEditedPriceValue, editPrice, getDefaultRetailOptionSmeetzPicture, productPicture, sharedStocksWithOverbooking, addToBasketWithAddons, _addToBasketWithAddons, priceMaxQuantityLimit, priceMinQuantityLimit, canIncrease, increase, decrease, hideDialog, groupTimeSlots, chooseTimeSlot, setShowTimeSlotsModal, openCalendar, isDateDisabled, selectDate, _selectDate, getAddonCalendarDays, addDaysToCalendar, headerMargin;

      return regeneratorRuntime.wrap(function _callee6$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              addDaysToCalendar = function _addDaysToCalendar(calendarDays, mainDate, maxDays, operation) {
                for (var i = 0; i < maxDays; i++) {
                  var newDate = mainDate[operation](i + 1, "day");

                  if (operation === "subtract") {
                    calendarDays.unshift(newDate);
                  } else {
                    calendarDays.push(newDate);
                  } // Only show two days before/after the main ticket date, the rest are selectable from the date picker


                  if (i === 1 && i < maxDays - 1) {
                    if (!showDatePicker.value) {
                      showDatePicker.value = true;
                    }

                    break;
                  }
                }
              };

              getAddonCalendarDays = function _getAddonCalendarDays() {
                var _mainTicketTimeSlot$v;

                var mainTicketStartDateTime = dayjs((_mainTicketTimeSlot$v = mainTicketTimeSlot.value) === null || _mainTicketTimeSlot$v === void 0 ? void 0 : _mainTicketTimeSlot$v.startDateTime);
                var calendarDays = [mainTicketStartDateTime]; // Max length should be 5 for UI
                // Handle previous days

                var maxPrevDays = maxDaysBeforeMainTicket.value || 0;
                addDaysToCalendar(calendarDays, mainTicketStartDateTime, maxPrevDays, "subtract"); // Handle next days

                var maxNextDays = maxDaysAfterMainTicket.value || 0;
                addDaysToCalendar(calendarDays, mainTicketStartDateTime, maxNextDays, "add");
                return calendarDays;
              };

              _selectDate = function _selectDate3() {
                _selectDate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(date) {
                  var _timeSlotsModalData$v2;

                  var selectedAddon, timeslots, groupedTimeSlots, _iterator10, _step10, addon, addonData, timeSlotsData;

                  return regeneratorRuntime.wrap(function _callee5$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          if (date) {
                            selectedDate.value = date;
                          } // else if no date argument passed then it was selected from calendar


                          selectedAddon = (_timeSlotsModalData$v2 = timeSlotsModalData.value) === null || _timeSlotsModalData$v2 === void 0 ? void 0 : _timeSlotsModalData$v2.addon;

                          if (!(selectedAddon && timeSlotsModalVisible.value)) {
                            _context8.next = 8;
                            break;
                          }

                          // if we have a selected addon and we're in the timeslots step, we change the timeslots to the new date selected
                          timeslots = addonsData.value[selectedAddon.id].timeslots || [];
                          groupedTimeSlots = groupTimeSlots(timeslots);
                          timeSlotsModalData.value = {
                            addon: selectedAddon,
                            groupedTimeSlots: groupedTimeSlots
                          };
                          _context8.next = 29;
                          break;

                        case 8:
                          // reload timeslots for addons that need it
                          _iterator10 = _createForOfIteratorHelper(addons.value);
                          _context8.prev = 9;

                          _iterator10.s();

                        case 11:
                          if ((_step10 = _iterator10.n()).done) {
                            _context8.next = 21;
                            break;
                          }

                          addon = _step10.value;
                          addonData = addonsData.value[addon.id];

                          if (!(addonData.addonAfterOffset || addonData.addonBeforeOffset)) {
                            _context8.next = 19;
                            break;
                          }

                          _context8.next = 17;
                          return getAddonTimeSlotsData(addon, addonData.pc);

                        case 17:
                          timeSlotsData = _context8.sent;
                          addonData.timeslots = timeSlotsData.timeslots;

                        case 19:
                          _context8.next = 11;
                          break;

                        case 21:
                          _context8.next = 26;
                          break;

                        case 23:
                          _context8.prev = 23;
                          _context8.t0 = _context8["catch"](9);

                          _iterator10.e(_context8.t0);

                        case 26:
                          _context8.prev = 26;

                          _iterator10.f();

                          return _context8.finish(26);

                        case 29:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee5, null, [[9, 23, 26, 29]]);
                }));
                return _selectDate.apply(this, arguments);
              };

              selectDate = function _selectDate2(_x4) {
                return _selectDate.apply(this, arguments);
              };

              isDateDisabled = function _isDateDisabled(date) {
                var dateJS = dayjs(date); // Disable before today

                if (dateJS.isBefore(dayjs(), "day")) {
                  return true;
                }

                return false;
              };

              openCalendar = function _openCalendar() {
                addonsDatepicker.value.focus();
              };

              setShowTimeSlotsModal = function _setShowTimeSlotsModa(show, addon, timeslots) {
                if (show && addon && timeslots) {
                  var priceCount = pricesCount.value[addonsData.value[addon.id].price.id];
                  var filteredTimeSlots = timeslots;

                  if (priceCount) {
                    filteredTimeSlots = timeslots.filter(function (timeslot) {
                      return timeslot.availability >= priceCount;
                    });
                  }

                  var groupedTimeSlots = groupTimeSlots(filteredTimeSlots);
                  timeSlotsModalData.value = {
                    addon: addon,
                    groupedTimeSlots: groupedTimeSlots
                  };
                } else {
                  timeSlotsModalData.value = null;
                }

                timeSlotsModalVisible.value = show;
              };

              chooseTimeSlot = function _chooseTimeSlot(data) {
                addonsData.value[data.addonId].chosenTimeslot = data.timeslot;
                timeSlotsModalData.value = null;
                timeSlotsModalVisible.value = false;
              };

              groupTimeSlots = function _groupTimeSlots(timeslots) {
                var groupedTimeSlots = {};
                timeslots.forEach(function (timeslot) {
                  var day = dayjs(timeslot.startDateTime).format("dddd DD MMM YYYY");
                  var hour = dayjs(timeslot.startDateTime).format("HH:mm");

                  if (!groupedTimeSlots[day]) {
                    groupedTimeSlots[day] = {};
                  }

                  if (!groupedTimeSlots[day][hour]) {
                    groupedTimeSlots[day][hour] = [];
                  }

                  groupedTimeSlots[day][hour].push(timeslot);
                });
                return groupedTimeSlots;
              };

              hideDialog = function _hideDialog() {
                if (props.modalProps.referrer === ModalComponents.Products && props.modalProps.goBack) {
                  ModalModule.setModalProps({});
                  ModalModule.setStatus(ModalStatus.Products);
                } else {
                  ModalModule.setStatus(ModalStatus.Hidden);
                }
              };

              decrease = function _decrease(priceId) {
                var priceCount = pricesCount.value[priceId];

                if (priceCount === 0) {
                  return;
                }

                pricesCount.value[priceId] = priceCount - 1;
              };

              increase = function _increase(addon, pc, priceId, index) {
                var _canIncrease = canIncrease(addon, pc, priceId),
                    res = _canIncrease.res,
                    shakeText = _canIncrease.shakeText;

                if (!res) {
                  if (shakeText) {
                    this.shakeText(addon.id);
                  }

                  return;
                }

                var priceCount = pricesCount.value[priceId];
                pricesCount.value[priceId] = priceCount + 1;
              };

              canIncrease = function _canIncrease2(addon, pc, priceId) {
                if (addonsData.value[addon.id].pc.isRecurring && !addonsData.value[addon.id].chosenTimeslot) {
                  return {
                    res: false,
                    shakeText: true
                  };
                }

                if (priceMaxQuantityLimit(addon, pc, priceId, PriceMaxQtyConstraint.REACHED).maxQtyLimit) {
                  return {
                    res: false
                  };
                }

                return {
                  res: true
                };
              };

              priceMinQuantityLimit = function _priceMinQuantityLimi(addon, pc, priceId) {
                var priceCount = pricesCount.value[priceId];

                if (!addon.isMandatory && priceCount === 0) {
                  return false;
                }

                var isRetail = pc.type === PCTypes[PCTypes.Retail];

                if (isRetail && priceCount < addon.minQuantity) {
                  return true;
                } else if (!isRetail && addonsData.value[addon.id].chosenTimeslot && priceCount < addon.minQuantity) {
                  return true;
                }

                return false;
              };

              priceMaxQuantityLimit = function _priceMaxQuantityLimi(addon, pc, priceId, constraint) {
                var isRetail = pc.type === PCTypes[PCTypes.Retail]; // if the price availability is less than the addon's max quantity, we reduce the latter to not oversell

                if (isRetail) {
                  var _pc$prices$find;

                  var quantity = ((_pc$prices$find = pc.prices.find(function (p) {
                    return p.id === priceId;
                  })) === null || _pc$prices$find === void 0 ? void 0 : _pc$prices$find.quantity) || 0;
                  addon.maxQuantity = Math.min(addon.maxQuantity, quantity);
                } else {
                  var _addonsData$value$add2;

                  var chosenTimeslot = addonsData.value[addon.id].chosenTimeslot;

                  if (!chosenTimeslot) {
                    // return false because not choosing a timeslot already prevents confirming
                    return {
                      maxQtyLimit: false
                    };
                  }

                  var timeSlotAvailablity = ((_addonsData$value$add2 = addonsData.value[addon.id].chosenTimeslot) === null || _addonsData$value$add2 === void 0 ? void 0 : _addonsData$value$add2.availability) || 0;
                  addon.maxQuantity = Math.min(addon.maxQuantity, timeSlotAvailablity);
                }

                var priceCount = pricesCount.value[priceId]; // initially, an addon's max quantity is it's maxQuantity field

                var maxQuantity = addon.maxQuantity;
                var maxQuantityReason = PriceQtyLimitReason.ADDON; // if an addon is displayed on the first step, it's max quantity comes from it's main price packageMaxQuantity field

                if (addon.displayPage === 1) {
                  var packageMaxQuantity = packageQuantities.value.maxQuantity;
                  var numberTickets = 0;
                  maxQuantity = packageMaxQuantity;

                  var _iterator4 = _createForOfIteratorHelper(addons.value),
                      _step4;

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      var otherAddon = _step4.value;

                      if (otherAddon.id !== addon.id && otherAddon.displayPage === 1) {
                        numberTickets += pricesCount.value[otherAddon.priceId];
                      }
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }

                  if (packageMaxQuantity - numberTickets < maxQuantity || priceCount > maxQuantity) {
                    // maxQuantity should be min(packageMaxQuantity - numberTickets, addon.maxQuantity)
                    maxQuantity = packageMaxQuantity - numberTickets;
                    maxQuantityReason = PriceQtyLimitReason.PACKAGE;
                  }
                }

                if (constraint === PriceMaxQtyConstraint.REACHED && priceCount >= maxQuantity && !sellOnSoldOut(pc.prices, pc.type) && !sharedStocksWithOverbooking(pc)) {
                  return {
                    maxQtyLimit: true,
                    reason: maxQuantityReason
                  };
                } else if (constraint === PriceMaxQtyConstraint.EXCEEDED && priceCount > maxQuantity && !sellOnSoldOut(pc.prices, pc.type) && !sharedStocksWithOverbooking(pc)) {
                  return {
                    maxQtyLimit: true,
                    reason: maxQuantityReason
                  };
                }

                return {
                  maxQtyLimit: false
                };
              };

              _addToBasketWithAddons = function _addToBasketWithAddon2() {
                _addToBasketWithAddons = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var allAddons, booking, _iterator8, _step8, _loop4, _ret3, addonModalProps, selectedProduct, isRetail, productCategory, pricesToAddToBasket, _iterator9, _step9, _loop5;

                  return regeneratorRuntime.wrap(function _callee4$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          isLoading.value = true;
                          allAddons = [];
                          booking = BookingModule.selectedBooking;

                          if (booking) {
                            _context7.next = 6;
                            break;
                          }

                          isLoading.value = false;
                          return _context7.abrupt("return");

                        case 6:
                          if (!addonsData.value) {
                            _context7.next = 26;
                            break;
                          }

                          _iterator8 = _createForOfIteratorHelper(addons.value);
                          _context7.prev = 8;
                          _loop4 = /*#__PURE__*/regeneratorRuntime.mark(function _loop4() {
                            var addon, addonPC, addonPrice, isRetail, chosenTimeslot, priceDiff, pssToDelete, pssIdsToDelete;
                            return regeneratorRuntime.wrap(function _loop4$(_context5) {
                              while (1) {
                                switch (_context5.prev = _context5.next) {
                                  case 0:
                                    addon = _step8.value;
                                    addonPC = addonsData.value[addon.id].pc;
                                    addonPrice = addonsData.value[addon.id].price;
                                    isRetail = addonPC.type === PCTypes[PCTypes.Retail];
                                    chosenTimeslot = addonsData.value[addon.id].chosenTimeslot;
                                    priceDiff = pricesDiff.value[addonPrice.id];

                                    if (!(priceDiff === 0)) {
                                      _context5.next = 10;
                                      break;
                                    }

                                    return _context5.abrupt("return", "continue");

                                  case 10:
                                    if (!(priceDiff < 0 && booking.uuid)) {
                                      _context5.next = 17;
                                      break;
                                    }

                                    pssToDelete = booking.pssList.filter(function (pss) {
                                      return pss.mainTicketUUID && pss.priceId === addonPrice.id;
                                    });
                                    pssIdsToDelete = pssToDelete.slice(0, priceDiff * -1).map(function (pss) {
                                      return String(pss.uuid);
                                    });
                                    _context5.next = 15;
                                    return deleteUnconfirmedTickets(pssIdsToDelete);

                                  case 15:
                                    _context5.next = 19;
                                    break;

                                  case 17:
                                    if (!(pricesCount.value[addonPrice.id] === 0)) {
                                      _context5.next = 19;
                                      break;
                                    }

                                    return _context5.abrupt("return", "continue");

                                  case 19:
                                    // if price quantity increased
                                    allAddons.push({
                                      automaticallyBook: addon.automaticallyBook,
                                      pssType: isRetail ? PSSType[PSSType.Retail] : PSSType[PSSType.Ticket],
                                      bookingUuid: booking.uuid,
                                      priceId: addon.priceId,
                                      categoryId: addonPC.id,
                                      priceValue: addon.displayedValue || 0,
                                      timeslot: chosenTimeslot,
                                      productCategory: addonPC,
                                      count: priceDiff,
                                      // create booking will throw if we have no seller id
                                      sellerId: booking.sellerId,
                                      sendTicket: addon.sendTicket,
                                      token: null,
                                      isAutomaticAddon: false,
                                      mainSlot: null,
                                      packagePriceId: addon.id,
                                      tokenEndDate: chosenTimeslot === null || chosenTimeslot === void 0 ? void 0 : chosenTimeslot.endDateTime,
                                      bookingReference: booking.reference
                                    });

                                  case 20:
                                  case "end":
                                    return _context5.stop();
                                }
                              }
                            }, _loop4);
                          });

                          _iterator8.s();

                        case 11:
                          if ((_step8 = _iterator8.n()).done) {
                            _context7.next = 18;
                            break;
                          }

                          return _context7.delegateYield(_loop4(), "t0", 13);

                        case 13:
                          _ret3 = _context7.t0;

                          if (!(_ret3 === "continue")) {
                            _context7.next = 16;
                            break;
                          }

                          return _context7.abrupt("continue", 16);

                        case 16:
                          _context7.next = 11;
                          break;

                        case 18:
                          _context7.next = 23;
                          break;

                        case 20:
                          _context7.prev = 20;
                          _context7.t1 = _context7["catch"](8);

                          _iterator8.e(_context7.t1);

                        case 23:
                          _context7.prev = 23;

                          _iterator8.f();

                          return _context7.finish(23);

                        case 26:
                          addonModalProps = props.modalProps.props;

                          if (addonModalProps) {
                            _context7.next = 31;
                            break;
                          }

                          isLoading.value = false;
                          hideDialog();
                          return _context7.abrupt("return");

                        case 31:
                          selectedProduct = addonModalProps.selectedProduct, isRetail = addonModalProps.isRetail, productCategory = addonModalProps.productCategory, pricesToAddToBasket = addonModalProps.pricesToAddToBasket;

                          if (pricesToAddToBasket) {
                            _context7.next = 34;
                            break;
                          }

                          return _context7.abrupt("return");

                        case 34:
                          _iterator9 = _createForOfIteratorHelper(pricesToAddToBasket);
                          _context7.prev = 35;
                          _loop5 = /*#__PURE__*/regeneratorRuntime.mark(function _loop5() {
                            var priceToAdd, price, pssQuantity, addonsToAdd;
                            return regeneratorRuntime.wrap(function _loop5$(_context6) {
                              while (1) {
                                switch (_context6.prev = _context6.next) {
                                  case 0:
                                    priceToAdd = _step9.value;
                                    price = priceToAdd.price, pssQuantity = priceToAdd.pssQuantity;
                                    addonsToAdd = [];
                                    /**
                                     * Find if the current price has addons
                                     * If it does, add its addons to addonsToAdd for insert and remove it from allAddons so it isn't inserted again
                                     */

                                    allAddons = allAddons.filter(function (addon) {
                                      var toAdd = price.addons.some(function (priceAddon) {
                                        return priceAddon.id === addon.packagePriceId;
                                      });

                                      if (toAdd) {
                                        addonsToAdd.push(addon);
                                        return false;
                                      }

                                      return true;
                                    });
                                    _context6.next = 6;
                                    return addToBasket({
                                      selectedProduct: selectedProduct,
                                      pssQuantity: 1,
                                      isRetail: isRetail,
                                      nonAutomaticAddons: addonsToAdd,
                                      price: price,
                                      productCategory: productCategory
                                    });

                                  case 6:
                                    if (!(pssQuantity > 1)) {
                                      _context6.next = 9;
                                      break;
                                    }

                                    _context6.next = 9;
                                    return addToBasket({
                                      selectedProduct: selectedProduct,
                                      pssQuantity: pssQuantity - 1,
                                      isRetail: isRetail,
                                      price: price,
                                      productCategory: productCategory
                                    });

                                  case 9:
                                  case "end":
                                    return _context6.stop();
                                }
                              }
                            }, _loop5);
                          });

                          _iterator9.s();

                        case 38:
                          if ((_step9 = _iterator9.n()).done) {
                            _context7.next = 42;
                            break;
                          }

                          return _context7.delegateYield(_loop5(), "t2", 40);

                        case 40:
                          _context7.next = 38;
                          break;

                        case 42:
                          _context7.next = 47;
                          break;

                        case 44:
                          _context7.prev = 44;
                          _context7.t3 = _context7["catch"](35);

                          _iterator9.e(_context7.t3);

                        case 47:
                          _context7.prev = 47;

                          _iterator9.f();

                          return _context7.finish(47);

                        case 50:
                          isLoading.value = false;
                          hideDialog();

                        case 52:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee4, null, [[8, 20, 23, 26], [35, 44, 47, 50]]);
                }));
                return _addToBasketWithAddons.apply(this, arguments);
              };

              addToBasketWithAddons = function _addToBasketWithAddon() {
                return _addToBasketWithAddons.apply(this, arguments);
              };

              sharedStocksWithOverbooking = function _sharedStocksWithOver(pc) {
                return pc.stockIds && pc.stockIds.length && pc.stockIds.includes(-1000);
              };

              productPicture = function _productPicture(pc) {
                if (pc) {
                  var isRetail = pc.type === PCTypes[PCTypes.Retail];

                  if (!isRetail) {
                    return pc === null || pc === void 0 ? void 0 : pc.product.pictureUrl;
                  } else {
                    return createImageproxyUrl(getDefaultRetailOptionSmeetzPicture(pc), {
                      width: 150
                      /*Number(PCSELECT_IMAGE_WIDTH)*/
                      ,
                      height: 150
                      /*Number(PCSELECT_IMAGE_HEIGHT)*/

                    }) || require("@/assets/images/icons/shopping-icon.png");
                  }
                } else {
                  return require("@/assets/images/icons/shopping-icon.png");
                }
              };

              getDefaultRetailOptionSmeetzPicture = function _getDefaultRetailOpti(pc) {
                var smeetzPicture = pc.prices[0].retail[0].smeetzPictures[0];
                return smeetzPicture;
              };

              editPrice = function _editPrice(priceId) {
                this.editingPrice = priceId; // show calculator for the user to enter the new price (show the old price as a placeholder in the calculator)

                this.showNewPriceCalculator = true;
                this.pricePlaceHolder = this.prices[priceId] ? this.prices[priceId].value / 100 : 0; // ModalModule.setStatus(ModalStatus.Calculator);
              };

              getEditedPriceValue = function _getEditedPriceValue(priceId) {
                var editedPrice = this.editedPrices.find(function (p) {
                  return p.priceId === priceId;
                });

                if (!editedPrice) {
                  return null;
                }

                return editedPrice.newPriceValue;
              };

              isPriceValueEditable = function _isPriceValueEditable(price) {
                var _BookingModule$select;

                if (!price.isEditable) return false;
                var pssList = (_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.pssList.filter(function (pss) {
                  return pss.priceId === price.id;
                });
                return pssList && pssList.length ? false : true;
              };

              togglePriceDescription = function _togglePriceDescripti(index, description, max) {
                var row = this.$refs.addonsRef[index];
                var currentDescription = row.querySelector(".price-description");
                var seeMoreLess = row.querySelector(".see-more");

                if (currentDescription.innerText.length < description.length) {
                  currentDescription.innerText = description;
                  seeMoreLess.innerText = t("button.see-less");
                } else {
                  currentDescription.innerText = truncatePriceDescription(description, max);
                  seeMoreLess.innerText = t("button.see-more");
                }
              };

              truncatePriceDescription = function _truncatePriceDescrip(text, max) {
                return text.length > max ? text.slice(0, max) + " ..." : text;
              };

              priceDescription = function _priceDescription(pc, price) {
                var isRetail = pc.type === PCTypes[PCTypes.Retail];
                return isRetail ? "" : price.descriptionLocale ? price.descriptionLocale[currentLanguage.value] || price.description : price.description;
              };

              priceName = function _priceName(pc, price) {
                // if it is a ticket product then we return the translated name of the price if there is translation, otherwise we return the price name
                // if it is a retail product then we return the translated name of the retail if there is translation, otherwise we return the price name
                // if it is a retail product but there are not retail options, there is only the default retail, then we consider the categoryName name and its translations
                var isRetail = pc.type === PCTypes[PCTypes.Retail];

                if (!isRetail) {
                  return price.nameLocale ? price.nameLocale[currentLanguage.value] || price.name : price.name;
                }

                if (isRetail) {
                  if (price.retail[0].type !== RetailOptionType.Default_Retail_Option) {
                    return price.retail[0].nameLocale ? price.retail[0].nameLocale[currentLanguage.value] || price.retail[0].name : price.retail[0].name;
                  }

                  if (price.retail[0].type === RetailOptionType.Default_Retail_Option) {
                    return (pc === null || pc === void 0 ? void 0 : pc.nameLocale[currentLanguage.value]) || (pc === null || pc === void 0 ? void 0 : pc.name);
                  }
                }
              };

              _getAddons = function _getAddons3() {
                _getAddons = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var _props$modalProps$pro2, _props$modalProps$pro3, _mainTicketTimeSlot$v3, _props$modalProps$pro4;

                  var pricesToAddToBasket, _iterator5, _step5, price, priceAddons, _iterator7, _step7, _loop2, _iterator6, _step6, _loop3, _ret2;

                  return regeneratorRuntime.wrap(function _callee3$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if ((_props$modalProps$pro2 = props.modalProps.props) !== null && _props$modalProps$pro2 !== void 0 && _props$modalProps$pro2.productCategory) {
                            _context4.next = 2;
                            break;
                          }

                          return _context4.abrupt("return");

                        case 2:
                          mainProductCategory.value = (_props$modalProps$pro3 = props.modalProps.props) === null || _props$modalProps$pro3 === void 0 ? void 0 : _props$modalProps$pro3.productCategory;

                          if (isMainPcRetail.value) {
                            _context4.next = 7;
                            break;
                          }

                          _context4.next = 6;
                          return BookingModule.fetchSelectedTimeslot();

                        case 6:
                          mainTicketTimeSlot.value = _context4.sent;

                        case 7:
                          selectDate(dayjs((_mainTicketTimeSlot$v3 = mainTicketTimeSlot.value) === null || _mainTicketTimeSlot$v3 === void 0 ? void 0 : _mainTicketTimeSlot$v3.startDateTime).toDate()); // get related addons

                          pricesToAddToBasket = (_props$modalProps$pro4 = props.modalProps.props) === null || _props$modalProps$pro4 === void 0 ? void 0 : _props$modalProps$pro4.pricesToAddToBasket;

                          if (pricesToAddToBasket) {
                            _context4.next = 11;
                            break;
                          }

                          return _context4.abrupt("return");

                        case 11:
                          _iterator5 = _createForOfIteratorHelper(pricesToAddToBasket);
                          _context4.prev = 12;

                          _iterator5.s();

                        case 14:
                          if ((_step5 = _iterator5.n()).done) {
                            _context4.next = 23;
                            break;
                          }

                          price = _step5.value;
                          _context4.next = 18;
                          return getPriceNonAutomaticAddons(price.price);

                        case 18:
                          priceAddons = _context4.sent;
                          _iterator7 = _createForOfIteratorHelper(priceAddons);

                          try {
                            _loop2 = function _loop2() {
                              var addon = _step7.value;
                              var alreadyExistingAddon = addons.value.find(function (a) {
                                return a.priceId === addon.priceId;
                              });

                              if (alreadyExistingAddon) {
                                /**
                                 * In case multiple prices were selected, and all have addons that overlap
                                 * we merge the addons into one and make it:
                                 * 1. mandatory if one of addons is mandatory
                                 * 2. min/max quantity is the sum of the min/max quantities of all addons
                                 */
                                alreadyExistingAddon.isMandatory = addon.isMandatory || alreadyExistingAddon.isMandatory;
                                alreadyExistingAddon.minQuantity += addon.minQuantity;
                                alreadyExistingAddon.maxQuantity += addon.maxQuantity;
                              } else {
                                addons.value.push(addon);
                              }
                            };

                            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                              _loop2();
                            }
                          } catch (err) {
                            _iterator7.e(err);
                          } finally {
                            _iterator7.f();
                          }

                        case 21:
                          _context4.next = 14;
                          break;

                        case 23:
                          _context4.next = 28;
                          break;

                        case 25:
                          _context4.prev = 25;
                          _context4.t0 = _context4["catch"](12);

                          _iterator5.e(_context4.t0);

                        case 28:
                          _context4.prev = 28;

                          _iterator5.f();

                          return _context4.finish(28);

                        case 31:
                          // get a record containing prices, product category and timeslots for each addon
                          _iterator6 = _createForOfIteratorHelper(addons.value);
                          _context4.prev = 32;
                          _loop3 = /*#__PURE__*/regeneratorRuntime.mark(function _loop3() {
                            var addon, pcByPrice, _timeSlotsData, _timeSlotsData2, _timeSlotsData3, _timeSlotsData4, _timeSlotsData5, _mainTicketTimeSlot$v4, addonPC, timeSlotsData, chosenTimeslot, _price, mainTicketStartDateTime;

                            return regeneratorRuntime.wrap(function _loop3$(_context3) {
                              while (1) {
                                switch (_context3.prev = _context3.next) {
                                  case 0:
                                    addon = _step6.value;
                                    _context3.next = 3;
                                    return getProductCategoryByPrice(addon.priceId);

                                  case 3:
                                    pcByPrice = _context3.sent;

                                    if (!pcByPrice) {
                                      _context3.next = 22;
                                      break;
                                    }

                                    addonPC = pcByPrice.toJSON();

                                    if (!groupedAddons.value[addonPC.name]) {
                                      groupedAddons.value[addonPC.name] = [addon];
                                    } else {
                                      groupedAddons.value[addonPC.name].push(addon);
                                    }

                                    chosenTimeslot = undefined;

                                    if (!(addonPC.isRecurring || !addonPC.isRecurring && addonPC.timeSlotCount === 1)) {
                                      _context3.next = 13;
                                      break;
                                    }

                                    _context3.next = 11;
                                    return getAddonTimeSlotsData(addon, addonPC);

                                  case 11:
                                    timeSlotsData = _context3.sent;

                                    if (!addonPC.isRecurring && addonPC.timeSlotCount === 1) {
                                      // if an addon is not recurring but still has a timeslot (single date event for example) then select the only available timeslot
                                      chosenTimeslot = timeSlotsData.timeslots[0];
                                    }

                                  case 13:
                                    _price = addonPC.prices.find(function (price) {
                                      return price.id === addon.priceId;
                                    });

                                    if (_price) {
                                      _context3.next = 16;
                                      break;
                                    }

                                    return _context3.abrupt("return", "continue");

                                  case 16:
                                    addonsData.value[addon.id] = {
                                      pc: addonPC,
                                      price: _price,
                                      timeslots: (_timeSlotsData = timeSlotsData) === null || _timeSlotsData === void 0 ? void 0 : _timeSlotsData.timeslots,
                                      addonBeforeOffset: (_timeSlotsData2 = timeSlotsData) === null || _timeSlotsData2 === void 0 ? void 0 : _timeSlotsData2.addonBeforeOffset,
                                      addonAfterOffset: (_timeSlotsData3 = timeSlotsData) === null || _timeSlotsData3 === void 0 ? void 0 : _timeSlotsData3.addonAfterOffset,
                                      chosenTimeslot: chosenTimeslot
                                    }; // bookable days are days which fit in the range of [mainTicketStart - addonBeforeOffset, mainTicketStart + addonAfterOffset]
                                    // now in the calendar, we only display bookable days to avoid giving the impression that an addon is available on a day that it isn't
                                    // this is done by keeping track of which addon has the largest offset from the main ticket start time

                                    if (!(!((_timeSlotsData4 = timeSlotsData) !== null && _timeSlotsData4 !== void 0 && _timeSlotsData4.addonBeforeOffset) || !((_timeSlotsData5 = timeSlotsData) !== null && _timeSlotsData5 !== void 0 && _timeSlotsData5.addonAfterOffset))) {
                                      _context3.next = 19;
                                      break;
                                    }

                                    return _context3.abrupt("return", "continue");

                                  case 19:
                                    mainTicketStartDateTime = dayjs((_mainTicketTimeSlot$v4 = mainTicketTimeSlot.value) === null || _mainTicketTimeSlot$v4 === void 0 ? void 0 : _mainTicketTimeSlot$v4.startDateTime);

                                    if (mainTicketStartDateTime.isSame(dayjs(), "day")) {
                                      // prevent displaying days of the past
                                      maxDaysBeforeMainTicket.value = 0;
                                    } else if (mainTicketStartDateTime.subtract(timeSlotsData.addonBeforeOffset, "day").isBefore(dayjs(), "day")) {
                                      // prevent displaying dates of the past if applying the offset takes us back to before today
                                      maxDaysBeforeMainTicket.value = mainTicketStartDateTime.diff(dayjs(), "day");
                                    } else {
                                      maxDaysBeforeMainTicket.value = Math.max(maxDaysBeforeMainTicket.value, timeSlotsData.addonBeforeOffset);
                                    }

                                    maxDaysAfterMainTicket.value = Math.max(maxDaysAfterMainTicket.value, timeSlotsData.addonAfterOffset);

                                  case 22:
                                  case "end":
                                    return _context3.stop();
                                }
                              }
                            }, _loop3);
                          });

                          _iterator6.s();

                        case 35:
                          if ((_step6 = _iterator6.n()).done) {
                            _context4.next = 42;
                            break;
                          }

                          return _context4.delegateYield(_loop3(), "t1", 37);

                        case 37:
                          _ret2 = _context4.t1;

                          if (!(_ret2 === "continue")) {
                            _context4.next = 40;
                            break;
                          }

                          return _context4.abrupt("continue", 40);

                        case 40:
                          _context4.next = 35;
                          break;

                        case 42:
                          _context4.next = 47;
                          break;

                        case 44:
                          _context4.prev = 44;
                          _context4.t2 = _context4["catch"](32);

                          _iterator6.e(_context4.t2);

                        case 47:
                          _context4.prev = 47;

                          _iterator6.f();

                          return _context4.finish(47);

                        case 50:
                          if (addonsData.value) {
                            _context4.next = 52;
                            break;
                          }

                          return _context4.abrupt("return");

                        case 52:
                          Object.keys(addonsData.value).forEach(function (id) {
                            var _BookingModule$select2;

                            // initialize price related objects (number of PSS in booking)
                            var addonId = Number(id);
                            var addon = addons.value.find(function (addon) {
                              return addon.id === addonId;
                            });
                            var addonDisplayedValue = (addon === null || addon === void 0 ? void 0 : addon.displayedValue) || 0;
                            var priceId = addonsData.value[addonId].price.id;
                            var mainTicketPSSInBooking = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.pssList.filter(function (pss) {
                              var _mainProductCategory$6;

                              return pss.productId === ((_mainProductCategory$6 = mainProductCategory.value) === null || _mainProductCategory$6 === void 0 ? void 0 : _mainProductCategory$6.product.id);
                            });

                            if (!mainTicketPSSInBooking || !mainTicketPSSInBooking.length) {
                              pricesCount.value[priceId] = 0;
                              pricesBookingCount.value[priceId] = 0;
                            } else {
                              var countInBooking = 0;
                              mainTicketPSSInBooking.forEach(function (mainPss) {
                                var _BookingModule$select3;

                                countInBooking += ((_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.pssList.filter(function (pss) {
                                  return pss.mainTicketUUID === mainPss.uuid && pss.priceId === priceId && pss.priceValue === addonDisplayedValue;
                                }).length) || 0;
                              });
                              pricesCount.value[priceId] = countInBooking;
                              pricesBookingCount.value[priceId] = countInBooking;
                            }
                          });

                        case 53:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee3, null, [[12, 25, 28, 31], [32, 44, 47, 50]]);
                }));
                return _getAddons.apply(this, arguments);
              };

              getAddons = function _getAddons2() {
                return _getAddons.apply(this, arguments);
              };

              _getAddonTimeSlotsData = function _getAddonTimeSlotsDat2() {
                _getAddonTimeSlotsData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(addon, addonPC, options) {
                  var _mainTicketTimeSlot$v2;

                  var timeslots, addonBeforeOffset, addonAfterOffset, startDateTime, mainTicketStartDateTime, minutesBeforeStartMin, minutesBeforeStartMax, minutesAfterStartMin, minutesAfterStartMax, beforeStartFrom, beforeStartTo, afterStartFrom, afterStartTo, _adjustAddonInterval, firstIntervalTimeSlots, secondIntervalTimeSlots, minAfter, minBefore, from, to, _adjustAddonInterval2;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          timeslots = []; // number of days the addon can start before the main ticket

                          addonBeforeOffset = 0; // number of days the addon can start after the main ticket

                          addonAfterOffset = 0;
                          startDateTime = (_mainTicketTimeSlot$v2 = mainTicketTimeSlot.value) === null || _mainTicketTimeSlot$v2 === void 0 ? void 0 : _mainTicketTimeSlot$v2.startDateTime;
                          mainTicketStartDateTime = startDateTime ? dayjs(startDateTime).utc() : dayjs().utc();
                          minutesBeforeStartMin = addon.minutesBeforeStartMin, minutesBeforeStartMax = addon.minutesBeforeStartMax, minutesAfterStartMin = addon.minutesAfterStartMin, minutesAfterStartMax = addon.minutesAfterStartMax;

                          if (!(minutesBeforeStartMin || minutesAfterStartMin)) {
                            _context2.next = 52;
                            break;
                          }

                          // if these values were set (currently only with an L2), then we use them to determine addons time intervals instead of minAfter and minBefore
                          beforeStartFrom = mainTicketStartDateTime.subtract(minutesBeforeStartMin, "minute").toISOString(); // may change

                          beforeStartTo = mainTicketStartDateTime.subtract(minutesBeforeStartMax, "minute").toISOString();
                          afterStartFrom = mainTicketStartDateTime.add(minutesAfterStartMin, "minute").toISOString();
                          afterStartTo = mainTicketStartDateTime.add(minutesAfterStartMax, "minute").toISOString(); // may change

                          addonBeforeOffset = dayjs(mainTicketStartDateTime).diff(beforeStartFrom, "day");
                          addonAfterOffset = dayjs(afterStartTo).diff(mainTicketStartDateTime, "day"); // adjust the time range if necessary and reassign beforeStartFrom, afterStartTo

                          _adjustAddonInterval = adjustAddonInterval(beforeStartFrom, afterStartTo, addonBeforeOffset, addonAfterOffset);
                          beforeStartFrom = _adjustAddonInterval.from;
                          afterStartTo = _adjustAddonInterval.to;

                          if (!(options !== null && options !== void 0 && options.fromRemoteFirst)) {
                            _context2.next = 34;
                            break;
                          }

                          // we try fetching from backend first
                          addonsLoading.value = true;
                          _context2.prev = 18;

                          if (!(minutesBeforeStartMin && minutesBeforeStartMax)) {
                            _context2.next = 22;
                            break;
                          }

                          _context2.next = 22;
                          return fetchAllPCsTimeslotsByTimeRange([addonPC.id], dayjs(beforeStartFrom).toDate(), dayjs(beforeStartTo).toDate(), true);

                        case 22:
                          if (!(minutesAfterStartMin && minutesAfterStartMax)) {
                            _context2.next = 25;
                            break;
                          }

                          _context2.next = 25;
                          return fetchAllPCsTimeslotsByTimeRange([addonPC.id], dayjs(afterStartFrom).toDate(), dayjs(afterStartTo).toDate(), true);

                        case 25:
                          _context2.next = 31;
                          break;

                        case 27:
                          _context2.prev = 27;
                          _context2.t0 = _context2["catch"](18);
                          LogService.info("Error while loading addons timeslots from backend", {
                            addonPCID: addonPC.id,
                            date: mainTicketStartDateTime.toISOString(),
                            error: _context2.t0
                          });
                          NotificationService.showGeneralResponseError();

                        case 31:
                          _context2.prev = 31;
                          addonsLoading.value = false;
                          return _context2.finish(31);

                        case 34:
                          if (!(minutesBeforeStartMin && minutesBeforeStartMax)) {
                            _context2.next = 42;
                            break;
                          }

                          _context2.next = 37;
                          return getFutureTimeSlotsByProductCategory2(Number(addonPC.id), beforeStartFrom, beforeStartTo);

                        case 37:
                          _context2.t1 = _context2.sent;

                          if (_context2.t1) {
                            _context2.next = 40;
                            break;
                          }

                          _context2.t1 = [];

                        case 40:
                          firstIntervalTimeSlots = _context2.t1;
                          // add timeslots
                          timeslots = timeslots.concat(firstIntervalTimeSlots);

                        case 42:
                          if (!(minutesAfterStartMin && minutesAfterStartMax)) {
                            _context2.next = 50;
                            break;
                          }

                          _context2.next = 45;
                          return getFutureTimeSlotsByProductCategory2(Number(addonPC.id), afterStartFrom, afterStartTo);

                        case 45:
                          _context2.t2 = _context2.sent;

                          if (_context2.t2) {
                            _context2.next = 48;
                            break;
                          }

                          _context2.t2 = [];

                        case 48:
                          secondIntervalTimeSlots = _context2.t2;
                          // add timeslots
                          timeslots = timeslots.concat(secondIntervalTimeSlots);

                        case 50:
                          _context2.next = 81;
                          break;

                        case 52:
                          // we use the usual minBefore, minAfter logic
                          minAfter = addon.minutesAfter || 0;
                          minBefore = addon.minutesBefore || 0;
                          from = mainTicketStartDateTime.subtract(minBefore, "minute").toISOString();
                          to = mainTicketStartDateTime.add(minAfter, "minute").toISOString();
                          addonBeforeOffset = dayjs(mainTicketStartDateTime).diff(from, "day");
                          addonAfterOffset = dayjs(to).diff(mainTicketStartDateTime, "day"); // adjust the time range if necessary and reassign from and to

                          _adjustAddonInterval2 = adjustAddonInterval(from, to, addonBeforeOffset, addonAfterOffset);
                          from = _adjustAddonInterval2.from;
                          to = _adjustAddonInterval2.to;

                          if (!(options !== null && options !== void 0 && options.fromRemoteFirst)) {
                            _context2.next = 75;
                            break;
                          }

                          // we try fetching from backend first
                          addonsLoading.value = true;
                          _context2.prev = 63;
                          _context2.next = 66;
                          return fetchAllPCsTimeslotsByTimeRange([addonPC.id], dayjs(from).toDate(), dayjs(to).toDate(), true);

                        case 66:
                          _context2.next = 72;
                          break;

                        case 68:
                          _context2.prev = 68;
                          _context2.t3 = _context2["catch"](63);
                          LogService.info("Error while loading addons timeslots from backend", {
                            addonPCID: addonPC.id,
                            date: mainTicketStartDateTime.toISOString(),
                            error: _context2.t3
                          });
                          NotificationService.showGeneralResponseError();

                        case 72:
                          _context2.prev = 72;
                          addonsLoading.value = false;
                          return _context2.finish(72);

                        case 75:
                          _context2.next = 77;
                          return getFutureTimeSlotsByProductCategory2(Number(addonPC.id), from, to);

                        case 77:
                          _context2.t4 = _context2.sent;

                          if (_context2.t4) {
                            _context2.next = 80;
                            break;
                          }

                          _context2.t4 = [];

                        case 80:
                          timeslots = _context2.t4;

                        case 81:
                          if (!(!timeslots.length && !(options !== null && options !== void 0 && options.fromRemoteFirst))) {
                            _context2.next = 83;
                            break;
                          }

                          return _context2.abrupt("return", getAddonTimeSlotsData(addon, addonPC, {
                            fromRemoteFirst: true
                          }));

                        case 83:
                          return _context2.abrupt("return", {
                            timeslots: timeslots,
                            addonBeforeOffset: addonBeforeOffset,
                            addonAfterOffset: addonAfterOffset
                          });

                        case 84:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[18, 27, 31, 34], [63, 68, 72, 75]]);
                }));
                return _getAddonTimeSlotsData.apply(this, arguments);
              };

              getAddonTimeSlotsData = function _getAddonTimeSlotsDat(_x, _x2, _x3) {
                return _getAddonTimeSlotsData.apply(this, arguments);
              };

              adjustAddonInterval = function _adjustAddonInterval3(from, to, addonBeforeOffset, addonAfterOffset) {
                if (addonBeforeOffset >= 1) {
                  from = dayjs.max(dayjs(selectedDate.value).startOf("day"), dayjs(from)).toISOString();
                }

                if (addonAfterOffset >= 1) {
                  to = dayjs.min(dayjs(selectedDate.value).endOf("day"), dayjs(to)).toISOString();
                }

                return {
                  from: from,
                  to: to
                };
              };

              _useI18n = useI18n({}), t = _useI18n.t;
              dialogVisible = dialogVisibleForStatus(ModalStatus.Addons);
              mainProductCategory = ref(null);
              currentLanguage = ref(getLanguage());
              mainTicketTimeSlot = ref(null);
              addons = ref([]);
              addonsData = ref({});
              groupedAddons = ref({});
              pricesCount = ref({});
              pricesBookingCount = ref({});
              isLoading = ref(false);
              timeSlotsModalVisible = ref(false);
              timeSlotsModalData = ref(null);
              addonsDatepicker = ref();
              selectedDate = ref(new Date());
              addonsLoading = ref(false);
              maxDaysBeforeMainTicket = ref(0);
              maxDaysAfterMainTicket = ref(0);
              showDatePicker = ref(false);
              priceDescriptionMaxLength = 80;

              (function (PriceMaxQtyConstraint) {
                PriceMaxQtyConstraint[PriceMaxQtyConstraint["REACHED"] = 0] = "REACHED";
                PriceMaxQtyConstraint[PriceMaxQtyConstraint["EXCEEDED"] = 1] = "EXCEEDED";
              })(PriceMaxQtyConstraint || (PriceMaxQtyConstraint = {}));

              (function (PriceQtyLimitReason) {
                PriceQtyLimitReason[PriceQtyLimitReason["PACKAGE"] = 0] = "PACKAGE";
                PriceQtyLimitReason[PriceQtyLimitReason["ADDON"] = 1] = "ADDON";
              })(PriceQtyLimitReason || (PriceQtyLimitReason = {}));

              isMainPcRetail = computed(function () {
                var _mainProductCategory$;

                return ((_mainProductCategory$ = mainProductCategory.value) === null || _mainProductCategory$ === void 0 ? void 0 : _mainProductCategory$.type) === PCTypes[PCTypes.Retail];
              });
              productCategoryName = computed(function () {
                var _mainProductCategory$2, _mainProductCategory$3, _mainProductCategory$4, _mainProductCategory$5;

                return isMainPcRetail.value ? ((_mainProductCategory$2 = mainProductCategory.value) === null || _mainProductCategory$2 === void 0 ? void 0 : _mainProductCategory$2.nameLocale[currentLanguage.value]) || ((_mainProductCategory$3 = mainProductCategory.value) === null || _mainProductCategory$3 === void 0 ? void 0 : _mainProductCategory$3.name) : ((_mainProductCategory$4 = mainProductCategory.value) === null || _mainProductCategory$4 === void 0 ? void 0 : _mainProductCategory$4.nameLocale[currentLanguage.value]) || ((_mainProductCategory$5 = mainProductCategory.value) === null || _mainProductCategory$5 === void 0 ? void 0 : _mainProductCategory$5.name);
              });
              pcselectPictureSize = computed(function () {
                return {
                  width: PCSELECT_IMAGE_WIDTH + PCSELECT_IMAGE_MEASUREMENT_UNIT,
                  height: PCSELECT_IMAGE_HEIGHT + PCSELECT_IMAGE_MEASUREMENT_UNIT
                };
              });
              isDisabled = computed(function () {
                if (!addonsData.value) {
                  return true;
                }

                var addonsIds = Object.keys(addonsData.value);

                var _loop = function _loop(i) {
                  var addonId = Number(addonsIds[i]);
                  var addon = addons.value.find(function (addon) {
                    return addon.id === addonId;
                  });

                  if (!addon) {
                    return "continue";
                  }

                  var addonPC = addonsData.value[addonId].pc;
                  var price = addonsData.value[addonId].price; // if data isn't initialized

                  if (!addonPC || !addonPC.prices || !addonPC.prices.length) {
                    return {
                      v: true
                    };
                  } // if mandatory addons weren't selected or don't meet minimum quantity requirement
                  else if (addon.isMandatory && (pricesCount.value[price.id] === 0 || pricesCount.value[price.id] < addon.minQuantity)) {
                    return {
                      v: true
                    };
                  } // for recurring tickets
                  else if (addonPC.isRecurring) {
                    var _addonsData$value$add;

                    // if no time slot was chosen
                    if (addon.isMandatory && !addonsData.value[addonId].chosenTimeslot) {
                      return {
                        v: true
                      };
                    } // if quantity was increased but no timeslot chosen


                    if (!addonsData.value[addonId].chosenTimeslot && pricesCount.value[price.id] > 0) {
                      return {
                        v: true
                      };
                    } // if a time slot was chosen, quantity increased but minimum quantity wasn't met


                    if (addonsData.value[addonId].chosenTimeslot && pricesCount.value[price.id] > 0 && pricesCount.value[price.id] < addon.minQuantity) {
                      return {
                        v: true
                      };
                    } // if time slot quantity exceeds available


                    var timeSlotAvailablity = ((_addonsData$value$add = addonsData.value[addonId].chosenTimeslot) === null || _addonsData$value$add === void 0 ? void 0 : _addonsData$value$add.availability) || 0;

                    if (pricesCount.value[price.id] > timeSlotAvailablity) {
                      return {
                        v: true
                      };
                    } // if recurring addon quantity exceeds max available


                    if (pricesCount.value[price.id] > addon.maxQuantity) {
                      return {
                        v: true
                      };
                    }
                  } // if retail product isn't available
                  else if (!sellOnSoldOut(addonPC.prices, addonPC.type) && !sharedStocksWithOverbooking(addonPC) && pricesCount.value[price.id] > price.quantity) {
                    return {
                      v: true
                    };
                  } // if retail is not mandatory, user selected increased quantity but it doesn't meet minimum quantity requirement.
                  else if (!addon.isMandatory && pricesCount.value[price.id] > 0 && pricesCount.value[price.id] < addon.minQuantity) {
                    return {
                      v: true
                    };
                  } // if addon quantity exceeds max available
                  else if (pricesCount.value[price.id] > addon.maxQuantity) {
                    return {
                      v: true
                    };
                  }
                };

                for (var i = 0; i < addonsIds.length; i++) {
                  var _ret = _loop(i);

                  if (_ret === "continue") continue;
                  if (_typeof(_ret) === "object") return _ret.v;
                }

                if (packageMaxQtyError.value || packageMinQtyError.value) {
                  return true;
                }

                return false;
              });
              pricesDiff = computed(function () {
                var diffs = {};

                if (!pricesCount.value) {
                  return {};
                }

                for (var _i = 0, _Object$keys = Object.keys(pricesCount.value); _i < _Object$keys.length; _i++) {
                  var priceId = _Object$keys[_i];
                  var numPriceId = Number(priceId);
                  diffs[numPriceId] = pricesCount.value[numPriceId] - pricesBookingCount.value[numPriceId];
                }

                return diffs;
              });
              selectedBooking = computed(function () {
                return BookingModule.selectedBooking;
              });
              modalTitle = computed(function () {
                if (timeSlotsModalVisible.value) {
                  return t("addons.timeslots");
                }

                return t("addons.addons");
              });
              modalHeaderTitle = computed(function () {
                var _timeSlotsModalData$v;

                var selectedAddon = (_timeSlotsModalData$v = timeSlotsModalData.value) === null || _timeSlotsModalData$v === void 0 ? void 0 : _timeSlotsModalData$v.addon;

                if (timeSlotsModalVisible.value && selectedAddon) {
                  var addonPC = addonsData.value[selectedAddon.id].pc;
                  var addonPrice = addonsData.value[selectedAddon.id].price;
                  var addonProductName = addonPC.product.nameLocale[currentLanguage.value] || addonPC.product.name || "";
                  var addonPriceName = priceName(addonPC, addonPrice);
                  var addonTitle = "".concat(addonProductName, " - ").concat(addonPriceName);
                  return addonTitle;
                }

                return productCategoryName.value;
              });
              showAddonsDates = computed(function () {
                for (var addonId in addonsData.value) {
                  var addon = addonsData.value[addonId];

                  if (addon.pc.isRecurring) {
                    return true;
                  }
                }

                return false;
              });
              /**
               * Calculates minimum and maximum quantities allowed for addons
               * according to backend logic, the total number of first step addons should be the number of booked main ticket multiplied by price.packageMin(Max)Quantity
               */

              packageQuantities = computed(function () {
                var _props$modalProps$pro;

                var minQuantity = 0;
                var maxQuantity = 0;
                var pricesToAddToBasket = (_props$modalProps$pro = props.modalProps.props) === null || _props$modalProps$pro === void 0 ? void 0 : _props$modalProps$pro.pricesToAddToBasket;

                if (!pricesToAddToBasket) {
                  return {
                    minQuantity: minQuantity,
                    maxQuantity: maxQuantity
                  };
                }

                var _iterator = _createForOfIteratorHelper(pricesToAddToBasket),
                    _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var priceInfo = _step.value;
                    var price = priceInfo.price,
                        pssQuantity = priceInfo.pssQuantity;
                    var packageMinQuantity = price.packageMinQuantity || 0; // use 0 as a fallback value to allow at least 1 addon

                    var packageMaxQuantity = price.packageMaxQuantity || 1; // use 1 as a fallback value to not block sales

                    minQuantity += pssQuantity * packageMinQuantity;
                    maxQuantity += pssQuantity * packageMaxQuantity;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return {
                  minQuantity: minQuantity,
                  maxQuantity: maxQuantity
                };
              });
              packageMaxQtyError = computed(function () {
                var numberTickets = 0;
                var packageMaxQuantity = packageQuantities.value.maxQuantity;

                var _iterator2 = _createForOfIteratorHelper(addons.value),
                    _step2;

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var addon = _step2.value;

                    if (addon.displayPage === 1) {
                      numberTickets += pricesCount.value[addon.priceId];
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (numberTickets > packageMaxQuantity) {
                  return true;
                }

                return false;
              });
              packageMinQtyError = computed(function () {
                var numberTickets = 0;
                var packageMinQuantity = packageQuantities.value.minQuantity;

                var _iterator3 = _createForOfIteratorHelper(addons.value),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var addon = _step3.value;

                    if (addon.displayPage === 1) {
                      numberTickets += pricesCount.value[addon.priceId];
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                if (numberTickets && numberTickets < packageMinQuantity) {
                  return true;
                }

                return false;
              });
              /**
               * Reduces the time range for fetching addon timeslots to [max(startOfSelectedDay, from), min(startOfSelectedDay, to)]
               * This avoids fetching and storing all timeslots if an addon can be booked days before or after the main ticket
               * @param from addon original bookable time range start
               * @param to addon original bookable time range end
               * @param addonBeforeOffset number of days an addon can be booked before the main ticket start time
               * @param addonAfterOffset number of days an addon can be booked after the main ticket start time
               * @returns (from, to) - adjusted time range to the current selected day
               */

              headerMargin = computed(function () {
                // adds some space for the back button on timeslots step
                if (timeSlotsModalVisible.value) {
                  return "4rem";
                }

                return "0";
              });
              return _context9.abrupt("return", {
                t: t,
                dialogVisible: dialogVisible,
                mainProductCategory: mainProductCategory,
                formatAndConvertToLocale: formatAndConvertToLocale,
                formatDateTime: formatDateTime,
                sellOnSoldOut: sellOnSoldOut,
                productCategoryName: productCategoryName,
                isMainPcRetail: isMainPcRetail,
                mainTicketTimeSlot: mainTicketTimeSlot,
                //addons,
                getAddons: getAddons,
                addonsData: addonsData,
                priceName: priceName,
                truncatePriceDescription: truncatePriceDescription,
                priceDescription: priceDescription,
                priceDescriptionMaxLength: priceDescriptionMaxLength,
                togglePriceDescription: togglePriceDescription,
                isPriceValueEditable: isPriceValueEditable,
                getEditedPriceValue: getEditedPriceValue,
                editPrice: editPrice,
                productPicture: productPicture,
                pcselectPictureSize: pcselectPictureSize,
                sharedStocksWithOverbooking: sharedStocksWithOverbooking,
                isLoading: isLoading,
                isDisabled: isDisabled,
                increase: increase,
                decrease: decrease,
                hideDialog: hideDialog,
                pricesCount: pricesCount,
                addToBasketWithAddons: addToBasketWithAddons,
                PCTypes: PCTypes,
                chooseTimeSlot: chooseTimeSlot,
                timeSlotsModalVisible: timeSlotsModalVisible,
                timeSlotsModalData: timeSlotsModalData,
                setShowTimeSlotsModal: setShowTimeSlotsModal,
                dayjs: dayjs,
                groupedAddons: groupedAddons,
                addonsDatepicker: addonsDatepicker,
                openCalendar: openCalendar,
                isDateDisabled: isDateDisabled,
                selectedDate: selectedDate,
                selectDate: selectDate,
                selectedBooking: selectedBooking,
                modalTitle: modalTitle,
                modalHeaderTitle: modalHeaderTitle,
                headerMargin: headerMargin,
                showAddonsDates: showAddonsDates,
                priceMaxQuantityLimit: priceMaxQuantityLimit,
                PriceMaxQtyConstraint: PriceMaxQtyConstraint,
                priceMinQuantityLimit: priceMinQuantityLimit,
                canIncrease: canIncrease,
                addonsLoading: addonsLoading,
                getAddonCalendarDays: getAddonCalendarDays,
                showDatePicker: showDatePicker,
                PriceQtyLimitReason: PriceQtyLimitReason,
                areObjectsEqual: areObjectsEqual,
                packageMaxQtyError: packageMaxQtyError,
                packageMinQtyError: packageMinQtyError,
                packageQuantities: packageQuantities
              });

            case 68:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee6);
    }))();
  },
  methods: {
    shakeText: debounce(function shakeText(addonId) {
      var textElement = this.$refs["selectTimeSlot-" + addonId];

      if (!textElement.length) {
        textElement = this.$refs["noTimeSlot-" + addonId];
      }

      if (!textElement.length) {
        return;
      }

      textElement[0].classList.add("shake-animation"); // Remove the shake class after the animation ends

      setTimeout(function () {
        textElement[0].classList.remove("shake-animation");
      }, 500);
    }, 500)
  }
});

import { useCssVars as _useCssVars } from 'vue';

var __injectCSSVars__ = function __injectCSSVars__() {
  _useCssVars(function (_ctx) {
    return {
      "06ed6e8a": _ctx.headerMargin,
      "d23765f6": _ctx.pcselectPictureSize.height,
      "aa4703b0": _ctx.pcselectPictureSize.width
    };
  });
};

var __setup__ = __default__.setup;
__default__.setup = __setup__ ? function (props, ctx) {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;